import React from "react";

type ConstructionBlockProps = {
  height?: number;
  width?: number;
};

export const ConstructionBlock = ({ height = 120, width = 120 }: ConstructionBlockProps) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 520 520"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group">
          <g id="construction-block">
            <path
              d="M520,260 C520,403.594 403.596,520 260,520 C116.406,520 0,403.594 0,260 C0,116.406 116.406,0 260,0 C403.596,0 520,116.406 520,260"
              id="Fill-4"
              fill="#87C7A8"
            ></path>
            <path
              d="M481,260 C481,382.054 382.056,481 260,481 C137.945,481 39,382.054 39,260 C39,137.945 137.945,39 260,39 C382.056,39 481,137.945 481,260"
              id="Fill-5"
              fill="#B9DCC7"
            ></path>
            <path
              d="M224.974,159.373 C224.202,159.373 223.431,159.078 222.842,158.489 L210.803,146.45 C209.625,145.273 209.625,143.363 210.803,142.187 C211.98,141.009 213.889,141.009 215.066,142.187 L227.105,154.226 C228.283,155.402 228.283,157.313 227.105,158.489 C226.517,159.078 225.744,159.373 224.974,159.373"
              id="Fill-6"
              fill="#2C3742"
            ></path>
            <path
              d="M212.937,159.373 C212.165,159.373 211.394,159.078 210.805,158.489 C209.627,157.313 209.627,155.402 210.805,154.226 L222.841,142.187 C224.019,141.009 225.928,141.01 227.105,142.186 C228.283,143.363 228.283,145.272 227.106,146.45 L215.068,158.489 C214.479,159.078 213.708,159.373 212.937,159.373"
              id="Fill-7"
              fill="#2C3742"
            ></path>
            <path
              d="M465.365,359.443 C464.593,359.443 463.822,359.148 463.233,358.56 L451.196,346.521 C450.018,345.343 450.018,343.436 451.196,342.257 C452.374,341.08 454.282,341.08 455.46,342.257 L467.496,354.296 C468.674,355.474 468.674,357.384 467.496,358.56 C466.907,359.148 466.136,359.443 465.365,359.443"
              id="Fill-8"
              fill="#2C3742"
            ></path>
            <path
              d="M453.33,359.443 C452.559,359.443 451.787,359.148 451.197,358.56 C450.021,357.384 450.021,355.474 451.197,354.296 L463.234,342.257 C464.413,341.08 466.32,341.08 467.499,342.257 C468.676,343.436 468.676,345.343 467.499,346.521 L455.462,358.56 C454.873,359.148 454.101,359.443 453.33,359.443"
              id="Fill-9"
              fill="#2C3742"
            ></path>
            <path
              d="M96.1,365.461 C95.328,365.461 94.556,365.167 93.967,364.578 L81.931,352.539 C80.753,351.361 80.753,349.453 81.931,348.276 C83.108,347.098 85.017,347.098 86.194,348.276 L98.232,360.314 C99.409,361.492 99.409,363.402 98.231,364.578 C97.643,365.167 96.871,365.461 96.1,365.461"
              id="Fill-10"
              fill="#2C3742"
            ></path>
            <path
              d="M84.063,365.461 C83.291,365.461 82.52,365.167 81.931,364.578 C80.753,363.4 80.753,361.492 81.931,360.314 L93.967,348.276 C95.145,347.098 97.054,347.098 98.231,348.276 C99.409,349.452 99.409,351.361 98.232,352.539 L86.194,364.578 C85.605,365.167 84.834,365.461 84.063,365.461"
              id="Fill-11"
              fill="#2C3742"
            ></path>
            <path
              d="M55.999,242.982 L27.487,242.982 C25.821,242.982 24.472,241.632 24.472,239.967 C24.472,238.301 25.821,236.952 27.487,236.952 L55.999,236.952 C57.664,236.952 59.014,238.301 59.014,239.967 C59.014,241.632 57.664,242.982 55.999,242.982"
              id="Fill-12"
              fill="#2C3742"
            ></path>
            <path
              d="M29.629,254.555 L9.903,254.555 C8.237,254.555 6.888,253.206 6.888,251.54 C6.888,249.875 8.237,248.525 9.903,248.525 L29.629,248.525 C31.294,248.525 32.644,249.875 32.644,251.54 C32.644,253.206 31.294,254.555 29.629,254.555"
              id="Fill-13"
              fill="#2C3742"
            ></path>
            <path
              d="M486.436,242.982 L468.211,242.982 C466.546,242.982 465.196,241.632 465.196,239.967 C465.196,238.301 466.546,236.952 468.211,236.952 L486.436,236.952 C488.1,236.952 489.45,238.301 489.45,239.967 C489.45,241.632 488.1,242.982 486.436,242.982"
              id="Fill-14"
              fill="#2C3742"
            ></path>
            <path
              d="M505.73,242.982 L497.327,242.982 C495.662,242.982 494.313,241.632 494.313,239.967 C494.313,238.301 495.662,236.952 497.327,236.952 L505.73,236.952 C507.396,236.952 508.745,238.301 508.745,239.967 C508.745,241.632 507.396,242.982 505.73,242.982"
              id="Fill-15"
              fill="#2C3742"
            ></path>
            <path
              d="M302.924,159.373 L269.928,159.373 C268.264,159.373 266.913,158.023 266.913,156.357 C266.913,154.691 268.264,153.342 269.928,153.342 L302.924,153.342 C304.588,153.342 305.939,154.691 305.939,156.357 C305.939,158.023 304.588,159.373 302.924,159.373"
              id="Fill-16"
              fill="#2C3742"
            ></path>
            <path
              d="M265.708,98.843 L237.814,98.843 C236.149,98.843 234.8,97.494 234.8,95.828 C234.8,94.163 236.149,92.813 237.814,92.813 L265.708,92.813 C267.373,92.813 268.724,94.163 268.724,95.828 C268.724,97.494 267.373,98.843 265.708,98.843"
              id="Fill-17"
              fill="#2C3742"
            ></path>
            <path
              d="M282.207,88.681 L258.439,88.681 C256.773,88.681 255.424,87.332 255.424,85.666 C255.424,84 256.773,82.651 258.439,82.651 L282.207,82.651 C283.871,82.651 285.222,84 285.222,85.666 C285.222,87.332 283.871,88.681 282.207,88.681"
              id="Fill-18"
              fill="#2C3742"
            ></path>
            <path
              d="M239.88,329.063 L193.784,329.063 C192.119,329.063 190.77,327.712 190.77,326.047 C190.77,324.383 192.119,323.032 193.784,323.032 L239.88,323.032 C241.545,323.032 242.895,324.383 242.895,326.047 C242.895,327.712 241.545,329.063 239.88,329.063"
              id="Fill-19"
              fill="#2C3742"
            ></path>
            <path
              d="M276.51,339.782 L232.118,339.782 C230.453,339.782 229.104,338.432 229.104,336.768 C229.104,335.103 230.453,333.752 232.118,333.752 L276.51,333.752 C278.175,333.752 279.525,335.103 279.525,336.768 C279.525,338.432 278.175,339.782 276.51,339.782"
              id="Fill-20"
              fill="#2C3742"
            ></path>
            <path
              d="M302.145,385.878 L281.572,385.878 C279.908,385.878 278.558,384.527 278.558,382.862 C278.558,381.198 279.908,379.848 281.572,379.848 L302.145,379.848 C303.809,379.848 305.159,381.198 305.159,382.862 C305.159,384.527 303.809,385.878 302.145,385.878"
              id="Fill-21"
              fill="#2C3742"
            ></path>
            <path
              d="M319.595,385.878 L313.015,385.878 C311.351,385.878 310,384.527 310,382.862 C310,381.198 311.351,379.848 313.015,379.848 L319.595,379.848 C321.26,379.848 322.61,381.198 322.61,382.862 C322.61,384.527 321.26,385.878 319.595,385.878"
              id="Fill-22"
              fill="#2C3742"
            ></path>
            <path
              d="M133.302,132.146 C143.337,132.146 151.482,140.292 151.482,150.327 C151.482,160.383 143.337,168.529 133.302,168.529 C123.248,168.529 115.121,160.383 115.121,150.327 C115.121,140.292 123.248,132.146 133.302,132.146"
              id="Fill-26"
              fill="#E9CA45"
            ></path>
            <path
              d="M386.72,132.146 C396.773,132.146 404.9,140.292 404.9,150.327 C404.9,160.383 396.773,168.529 386.72,168.529 C376.686,168.529 368.539,160.383 368.539,150.327 C368.539,140.292 376.686,132.146 386.72,132.146"
              id="Fill-27"
              fill="#E9CA45"
            ></path>
            <path
              d="M133.302,132.146 C131.031,132.146 128.868,132.582 126.865,133.34 C133.729,135.943 138.619,142.562 138.619,150.327 C138.619,158.112 133.729,164.735 126.865,167.336 C128.868,168.096 131.031,168.529 133.302,168.529 C143.337,168.529 151.482,160.383 151.482,150.327 C151.482,140.292 143.337,132.146 133.302,132.146"
              id="Fill-28"
              fill="#FFF5BE"
            ></path>
            <path
              d="M386.72,132.146 C384.45,132.146 382.285,132.582 380.283,133.34 C387.146,135.943 392.037,142.562 392.037,150.327 C392.037,158.112 387.146,164.735 380.283,167.336 C382.285,168.096 384.45,168.529 386.72,168.529 C396.752,168.529 404.902,160.383 404.902,150.327 C404.902,140.292 396.752,132.146 386.72,132.146"
              id="Fill-29"
              fill="#FFF5BE"
            ></path>
            <polyline
              id="Fill-30"
              fill="#FFFFFE"
              points="164.648 196.166 86.092 280.894 86.092 196.166 164.648 196.166"
            ></polyline>
            <polyline
              id="Fill-31"
              fill="#FFFFFE"
              points="299.587 196.166 218.955 283.124 151.482 283.124 232.118 196.166 299.587 196.166"
            ></polyline>
            <polyline
              id="Fill-32"
              fill="#FFFFFE"
              points="433.928 196.166 433.928 196.81 353.896 283.124 286.425 283.124 367.059 196.166 433.928 196.166"
            ></polyline>
            <polyline
              id="Fill-33"
              fill="#C8466F"
              points="433.928 196.81 433.928 283.124 353.896 283.124 433.928 196.81"
            ></polyline>
            <polyline
              id="Fill-34"
              fill="#C8466F"
              points="367.059 196.166 286.425 283.124 218.955 283.124 299.587 196.166 367.059 196.166"
            ></polyline>
            <polyline
              id="Fill-35"
              fill="#C8466F"
              points="232.118 196.166 151.482 283.124 86.092 283.124 86.092 280.894 164.648 196.166 232.118 196.166"
            ></polyline>
            <polyline
              id="Fill-36"
              fill="#F0F1EF"
              points="143.209 217.605 144.771 217.605 164.648 196.166 86.092 196.166 86.092 217.605 143.209 217.605"
            ></polyline>
            <polyline
              id="Fill-37"
              fill="#F0F1EF"
              points="278.147 217.605 279.707 217.605 299.587 196.166 232.118 196.166 212.238 217.605 278.147 217.605"
            ></polyline>
            <polyline
              id="Fill-38"
              fill="#F0F1EF"
              points="367.059 196.166 347.179 217.605 412.489 217.605 412.489 219.931 433.928 196.81 433.928 196.166 367.059 196.166"
            ></polyline>
            <polyline
              id="Fill-39"
              fill="#AB395D"
              points="412.489 283.124 433.928 283.124 433.928 196.81 412.489 219.931 412.489 283.124"
            ></polyline>
            <polyline
              id="Fill-40"
              fill="#AB395D"
              points="345.619 217.605 347.179 217.605 367.059 196.166 299.587 196.166 279.707 217.605 345.619 217.605"
            ></polyline>
            <polyline
              id="Fill-41"
              fill="#AB395D"
              points="210.68 217.605 212.238 217.605 232.118 196.166 164.648 196.166 144.771 217.605 210.68 217.605"
            ></polyline>
            <path
              d="M429.908,279.103 L363.105,279.103 L429.908,207.058 L429.908,279.103 Z M137.322,425.708 L382.699,425.708 L382.699,287.144 L137.322,287.144 L137.322,425.708 Z M166.403,200.186 L222.908,200.186 L149.729,279.103 L93.233,279.103 L166.403,200.186 Z M155.438,200.186 L90.111,270.645 L90.111,200.186 L155.438,200.186 Z M217.201,279.103 L160.692,279.103 L233.873,200.186 L290.376,200.186 L217.201,279.103 Z M284.67,279.103 L228.165,279.103 L301.342,200.186 L357.849,200.186 L284.67,279.103 Z M352.14,279.103 L295.636,279.103 L368.814,200.186 L425.314,200.186 L352.14,279.103 Z M119.142,150.327 C119.142,142.519 125.493,136.167 133.302,136.167 C141.11,136.167 147.463,142.519 147.463,150.327 C147.463,158.147 141.11,164.51 133.302,164.51 C125.493,164.51 119.142,158.147 119.142,150.327 Z M372.559,150.327 C372.559,142.519 378.911,136.167 386.72,136.167 C394.528,136.167 400.881,142.519 400.881,150.327 C400.881,158.147 394.528,164.51 386.72,164.51 C378.911,164.51 372.559,158.147 372.559,150.327 Z M433.928,192.146 L390.74,192.146 L390.74,172.177 C401.067,170.277 408.92,161.206 408.92,150.327 C408.92,138.085 398.96,128.126 386.72,128.126 C374.479,128.126 364.519,138.085 364.519,150.327 C364.519,161.206 372.372,170.277 382.699,172.177 L382.699,192.146 L137.322,192.146 L137.322,172.177 C147.65,170.278 155.503,161.206 155.503,150.327 C155.503,138.085 145.544,128.126 133.302,128.126 C121.061,128.126 111.102,138.085 111.102,150.327 C111.102,161.206 118.953,170.278 129.282,172.178 L129.282,192.146 L86.092,192.146 C83.871,192.146 82.071,193.945 82.071,196.166 L82.071,283.124 C82.071,285.344 83.871,287.144 86.092,287.144 L129.282,287.144 L129.282,425.708 L86.092,425.708 C83.871,425.708 82.071,427.508 82.071,429.728 C82.071,431.948 83.871,433.748 86.092,433.748 L409.788,433.748 C412.008,433.748 413.808,431.948 413.808,429.728 C413.808,427.508 412.008,425.708 409.788,425.708 L390.74,425.708 L390.74,287.144 L433.928,287.144 C436.148,287.144 437.948,285.344 437.948,283.124 L437.948,196.166 C437.948,193.945 436.148,192.146 433.928,192.146 Z"
              id="Fill-42"
              fill="#2C3742"
            ></path>
            <path
              d="M133.302,118.673 C135.522,118.673 137.322,116.873 137.322,114.652 L137.322,90.748 C137.322,88.528 135.522,86.728 133.302,86.728 C131.082,86.728 129.282,88.528 129.282,90.748 L129.282,114.652 C129.282,116.873 131.082,118.673 133.302,118.673"
              id="Fill-43"
              fill="#2C3742"
            ></path>
            <path
              d="M105.988,120.102 C106.779,121.12 107.966,121.652 109.163,121.652 C110.025,121.652 110.896,121.375 111.629,120.805 C113.381,119.441 113.696,116.915 112.332,115.163 L97.647,96.295 C96.285,94.543 93.759,94.227 92.006,95.592 C90.254,96.956 89.938,99.482 91.303,101.234 L105.988,120.102"
              id="Fill-44"
              fill="#2C3742"
            ></path>
            <path
              d="M154.978,120.807 C155.711,121.377 156.58,121.652 157.441,121.652 C158.64,121.652 159.826,121.119 160.618,120.099 L175.281,101.231 C176.644,99.479 176.328,96.953 174.574,95.59 C172.82,94.227 170.296,94.544 168.934,96.298 L154.271,115.166 C152.908,116.919 153.224,119.444 154.978,120.807"
              id="Fill-45"
              fill="#2C3742"
            ></path>
            <path
              d="M386.72,118.673 C388.939,118.673 390.74,116.873 390.74,114.652 L390.74,90.748 C390.74,88.528 388.939,86.728 386.72,86.728 C384.499,86.728 382.699,88.528 382.699,90.748 L382.699,114.652 C382.699,116.873 384.499,118.673 386.72,118.673"
              id="Fill-46"
              fill="#2C3742"
            ></path>
            <path
              d="M359.405,120.1 C360.198,121.12 361.384,121.652 362.581,121.652 C363.445,121.652 364.313,121.377 365.047,120.807 C366.8,119.443 367.115,116.918 365.753,115.165 L351.086,96.297 C349.722,94.542 347.195,94.229 345.444,95.59 C343.692,96.954 343.376,99.479 344.738,101.232 L359.405,120.1"
              id="Fill-47"
              fill="#2C3742"
            ></path>
            <path
              d="M408.393,120.807 C409.127,121.377 409.994,121.652 410.857,121.652 C412.056,121.652 413.24,121.119 414.033,120.1 L428.699,101.232 C430.061,99.479 429.745,96.953 427.992,95.59 C426.239,94.229 423.715,94.542 422.351,96.297 L407.686,115.165 C406.323,116.918 406.639,119.444 408.393,120.807"
              id="Fill-48"
              fill="#2C3742"
            ></path>
            <path
              d="M431.764,425.708 L424.261,425.708 C422.041,425.708 420.24,427.508 420.24,429.728 C420.24,431.948 422.041,433.748 424.261,433.748 L431.764,433.748 C433.982,433.748 435.783,431.948 435.783,429.728 C435.783,427.508 433.982,425.708 431.764,425.708"
              id="Fill-49"
              fill="#2C3742"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
